import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { useContext } from 'react';
import ServicesContext from '../../contexts/ServicesContext';
import { configurationKeys } from '../../queryKeys/configuration';

export function useGetFileExtensions(): UseQueryResult<string[], unknown> {
  const servicesCtx = useContext(ServicesContext);

  const getAllowedFileExtensions = () => {
    if (servicesCtx?.configurationService) {
      return servicesCtx.configurationService.getAllowedFileExtensions();
    }
    throw new Error('Services context not initialized');
  };

  return useQuery({
    queryKey: configurationKeys.fileExtensions,
    queryFn: getAllowedFileExtensions,
    retry: 0,
    staleTime: Infinity,
    gcTime: 180000
  });
}
